import { render, staticRenderFns } from "./EcgSetting.vue?vue&type=template&id=2c453bfa&scoped=true&"
import script from "./EcgSetting.vue?vue&type=script&lang=ts&"
export * from "./EcgSetting.vue?vue&type=script&lang=ts&"
import style0 from "./EcgSetting.vue?vue&type=style&index=0&id=2c453bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c453bfa",
  null
  
)

export default component.exports